import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const ProblemSection = () => {
  const problems = [
  {
    icon: 'ExclamationTriangleIcon',
    title: 'Artificial Preservatives',
    description: 'Commercial products loaded with chemicals that harm your family\'s health'
  },
  {
    icon: 'XCircleIcon',
    title: 'Lost Authenticity',
    description: 'Mass-produced foods that taste nothing like grandmother\'s recipes'
  },
  {
    icon: 'BeakerIcon',
    title: 'Unknown Ingredients',
    description: 'Mysterious additives and processing methods you can\'t trust'
  }];


  return (
    <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-6">
        <div className="mb-12 text-center">
          <h2 className="font-heading mb-4 text-3xl font-bold text-foreground lg:text-4xl">
            Remember the <span className="text-primary">Authentic Taste</span>?
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Modern commercial foods have lost the soul of traditional Indian cooking.
            Preservatives, artificial flavors, and mass production have replaced
            the love and authenticity of homemade recipes.
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="relative overflow-hidden rounded-2xl bg-muted p-8 shadow-cta">
            <div className="absolute right-0 top-0 h-32 w-32 rounded-bl-full bg-error/10" />
            <h3 className="font-heading mb-6 text-2xl font-bold text-foreground">
              Commercial Products
            </h3>
            <div className="space-y-4">
              {problems.map((problem, index) =>
              <div key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 rounded-lg bg-error/10 p-2">
                    <Icon
                    name={problem.icon as any}
                    size={24}
                    className="text-error" />

                  </div>
                  <div>
                    <h4 className="mb-1 font-bold text-foreground">
                      {problem.title}
                    </h4>
                    <p className="text-sm text-muted-foreground">
                      {problem.description}
                    </p>
                  </div>
                </div>
              )}
            </div>
            <div className="mt-6">
              <AppImage
                src="/assets/images/pickle-jar-1766910936605.jpg"
                alt="Pale commercial pickle jars with artificial coloring and preservatives on sterile white background"
                className="h-48 w-full rounded-lg object-cover opacity-60" />

            </div>
          </div>

          <div className="relative overflow-hidden rounded-2xl bg-success/5 p-8 shadow-cta">
            <div className="absolute right-0 top-0 h-32 w-32 rounded-bl-full bg-success/10" />
            <h3 className="font-heading mb-6 text-2xl font-bold text-foreground">
              Granny'z Farm Fresh
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 rounded-lg bg-success/10 p-2">
                  <Icon name="CheckCircleIcon" size={24} className="text-success" />
                </div>
                <div>
                  <h4 className="mb-1 font-bold text-foreground">
                    100% Natural Ingredients
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    Only farm-fresh produce and traditional spices, zero chemicals
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 rounded-lg bg-success/10 p-2">
                  <Icon name="HeartIcon" size={24} className="text-success" />
                </div>
                <div>
                  <h4 className="mb-1 font-bold text-foreground">
                    Authentic Traditional Recipes
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    Time-honored methods passed down through generations
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 rounded-lg bg-success/10 p-2">
                  <Icon name="EyeIcon" size={24} className="text-success" />
                </div>
                <div>
                  <h4 className="mb-1 font-bold text-foreground">
                    Complete Transparency
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    Know exactly what goes into every jar we make
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-6">
              <AppImage
                src="/assets/images/pickles-1766911031453.jpg"
                alt="Vibrant homemade pickle jars with fresh ingredients and golden oil on traditional wooden table with spices"
                className="h-48 w-full rounded-lg object-cover" />

            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ProblemSection;